import { useTranslation } from 'react-i18next'

const GymTeacherEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="gymteacher-end-title"
      {...props}
    >
      <title id="gymteacher-end-title">{t('antagonists:gymteacher:components:end')}</title>
      <defs>
        <clipPath id="b">
          <path
            d="M1682.72 373.62c5.73-6.08 19.69-24.49 24.31-30.98 7.61-10.69 8.51-54.39 7.93-72.95-.58-18.54-2.62-54.56-6.57-62.47-3.95-7.91-16.85-21.68-53.35-19.17-36.52 2.52-52.07 22.4-55.2 35.83-3.14 13.43 1.43 49.57 1.89 69.04.46 19.47 7.5 39.87 13.34 50.69 5.82 10.83 18.44 26.73 29.32 33.13 10.89 6.4 34.02 1.45 38.35-3.14l-.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="c">
          <path
            d="M1581.47 711.11s37.37 15.39 94.52 17.58 104.42-12.09 104.42-12.09l4.45 16.8s23.36 45.65 26.55 96.61c3.19 50.96 35.09 171.89 35.09 171.89s-39.34 5.41-71.18 10.72c-31.85 5.31-72.2-1.07-72.2-1.07s-33.97-93.43-41.4-157.13c-7.43-63.71-69.01-104.05-69.01-104.05l-11.24-39.29v.03Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="d">
          <path
            d="M1547.69 1009.12s41.84-11.34 71.56-4.97c29.73 6.37 60.52 6.37 60.52 6.37s27.6-124.23 26.55-121.04c-1.07 3.19-12.75-161.39-12.75-161.39s-62.64-3.19-78.56-3.19-29.73-8.49-29.73-8.49l-2.12 15.92s-19.11 12.75-19.11 54.15-16.36 222.63-16.36 222.63v.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="e">
          <path
            d="M1608.66 380.1s3.45 8.84 18.18 28.5c14.75 19.66 38.32 39.77 38.32 39.77s27.81-28.41 37.63-42.16c9.82-13.75 11.99-36.92 11.99-36.92s44.22 16.21 60.43 22.6c16.21 6.39 30.3 14.88 33.73 22.74 3.45 7.87-18.51 57.84-19.98 78.97-1.48 21.13 4.91 112.52 4.42 134.12-.49 21.62 8.36 94.83 12.78 120.37 4.42 25.56 2.81 35.06 2.81 35.06s-85.79 14.39-140.32 18.33c-54.54 3.93-108.14-7.47-108.14-7.47s8.36-52.3 13.75-83.26 6.88-102.68 5.9-119.88c-.98-17.2-17.2-90.9-28.01-117.92-10.81-27.02-39.07-31.18-24.08-44.71 8.04-7.24 28.99-20.14 42.74-27.02s37.83-21.13 37.83-21.13l.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.f,.g{fill:none}.g{stroke:#272a3e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.68px}.h{fill:#f8f7f0}.i{fill:#f1f1f3}.j{fill:#e5ca9c}.k{fill:#feca1b}.l{fill:#8cabbc}.m{fill:#d4a55e}.n{fill:#406229}.o{fill:#464640}.p{fill:#4a4630}.q{fill:#272a3e}.r{clip-path:url(#c)}.s{clip-path:url(#b)}.t{clip-path:url(#e)}.u{clip-path:url(#d)}'
          }
        </style>
      </defs>
      <path
        d="M1515.14 555.18s11.45 75.04 11.31 89.97c-.18 20.36 16.06 32.11 16.06 32.11s38.38-5.32 40.44-23.67c2.06-18.33.47-56.11-2.1-72.2-2.58-16.07-13.4-48.99-13.4-48.99l-52.29 22.78h-.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1543.82 637.7c-15.13 18.1-11.04 33.5 9.07 54.94 22.23 23.68 87.04 82.04 92.85 89.02s9.7 12.06 16.45 18.08c6.77 6.02 13.53 10.75 13.53 10.75l11.57-31.12s-9.96-5.35-20.01-20.92c-10.05-15.58-51.83-80.13-62.84-97.94-11.02-17.81-42.57-44.39-60.63-22.81ZM1626.01 872.56c4.51 4.64 24.46 19.01 29.25 22.06 4.79 3.03 44.28-10.54 44.28-10.54s-2.93-7.17-7.97-6.95c-5.05.21-6.36 1.07-6.36 1.07l6.94-5.02s-4.28-7.43-9.47-5.6c-5.18 1.83-16.12 5.61-16.12 5.61s-9.9-5.18-15.75-12.79c-5.29-6.88-2.07-15.9 5.5-8.72 7.58 7.17 14.5 14.81 18.19 15.87 3.69 1.07 10.31-1.45 10.31-1.45s-9.77-15.23-13.1-19.55c-4.33-5.6-12.58-21.91-19.06-27.95-6.48-6.02-25.27-14.56-29.19-19.59-6.62-8.49-10.96-21.52-10.96-21.52l-16.71 32.71s5.93 12.32 11.33 20.83c4.96 7.81 15.17 37.74 18.88 41.55v-.03ZM1779.21 513.55s4.57 79.14 4.59 89.51c0 10.37 6.6 35.44 6.6 35.44l44.54-6.83s4.04-27.17 3.74-44.27c-.3-17.09-.35-85.59-.35-85.59l-59.12 11.76v-.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1837.07 589s-46.71 24.53-61.59 52.9c-14.88 28.38-42.71 94.78-49.8 104.53s-15.51 16.51-15.51 16.51l22.16 22.99s3.74 1.19 9.55-5.84c5.79-7.03 8.8-13.54 20.22-26.81 11.42-13.27 56.74-70.22 66.44-88.56 11.53-21.76 8.54-75.74 8.54-75.74v.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1756.93 751.96s-32.52 15.72-37.31 21.12-18.45 24.7-23.33 30.28c-4.89 5.58-8.43 10.95-8.43 10.95s6.31 9.24 16.88 1.46 17.05-21.81 21.55-18.02-8.89 16.1-14.46 19.84c-5.57 3.74-13.34.55-15.37 2.84-2.04 2.29-4.5 3.6-4.5 3.6s-12.53-2.2-15.39 1.11c-2.85 3.29-4.44 7.81-4.44 7.81s38.79 12.67 42.88 11.54 31.96-17.76 36.35-21.16c4.39-3.42 18.8-29.66 24.05-38.49s8.11-10.4 11.01-16.38 14.04-33.84 14.04-33.84l-29.64-11.91s-2.7 20.36-13.89 29.25ZM1617.39 283.99s5.25 46.37 6.13 64.74c.87 18.37-11.97 32.27-19.85 35.76-7.87 3.51-53.98 32.08-53.98 32.08l2.07 47.65 106.75 108.51 93.62-137.37 13.13-41.99c-.2.03-47.67-7.5-55.09-31.41-7.56-24.37-3.54-70.08-3.54-70.08l-89.25-7.87v-.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1604.97 283.71s-8.75-9.16-14.44-6.82.49 11.73.91 19.7c.41 7.97 3.37 18.08 8.36 18.62s12.87-3.87 12.17-3.83-6.98-27.68-6.98-27.68h-.02ZM1709.98 278.41s9.06-10.16 16.51-5.35c7.46 4.8-.59 12.76-2.15 19.72-1.56 6.95-2.88 16.48-9.1 18.16-6.22 1.69-11.13-.73-11.13-.73l5.87-31.79Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1682.72 373.62c5.73-6.08 19.69-24.49 24.31-30.98 7.61-10.69 8.51-54.39 7.93-72.95-.58-18.54-2.62-54.56-6.57-62.47-3.95-7.91-16.85-21.68-53.35-19.17-36.52 2.52-52.07 22.4-55.2 35.83-3.14 13.43 1.43 49.57 1.89 69.04.46 19.47 7.5 39.87 13.34 50.69 5.82 10.83 18.44 26.73 29.32 33.13 10.89 6.4 34.02 1.45 38.35-3.14l-.02.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#b)',
        }}
      >
        <path
          d="M1656 247.77c12.55-.52 31.85-12.73 35.13-13.95 3.92-1.46 7.82-1.43 9.64 1.36s7.21 9.24 5.32 16.16c-1.89 6.92-3.32 11.95-3.32 11.95l7.96 22.09 4.53-.99 15.23-95.32-71.73-27.63-69.75 49.05 12.7 82.39 4.65-2.04 4.97-21.93s-5.47-12.17-4.33-19.01c1.69-10.05 9.16-11.82 14.17-10.55 5.02 1.27 12.47 9.29 34.83 8.39v.03Z"
          style={{
            fill: '#4a4630',
          }}
        />
      </g>
      <path
        d="M1642.03 348.12c1.36 1.59 4.62-1.07 7.58.87s8.65 4.09 12.88 2.41c6.85-2.7 7.06-7.75 8.55-9.36 3.28-3.51 5.09-3.06 4.62-5.9-.37-2.18-10.58-1.89-12.69-.63-4.28 2.56-3.26 2.62-4.83 3.49s-3.43-.98-7.03 1.24-10.81 5.9-9.1 7.88h.02Z"
        style={{
          fill: '#e5ca9c',
        }}
      />
      <path
        d="M1667.35 269.01c.69.17 19.35-.05 23.39 1.19s10.78 10.16 10.78 10.16l-3.75 2.45s-6.89-5.34-9.87-7.03c-2.96-1.69-20.27-.17-20.27-.17l-.3-6.6h.02ZM1648.32 284.25l-.44-6.75s-21.97.63-24.96 2.07-10.43 9.74-10.43 9.74l3.46 2.35s6.37-5.49 10.61-6.1c4.24-.61 21.76-1.3 21.76-1.3v-.02Z"
        style={{
          fill: '#464640',
        }}
      />
      <path
        d="M1633.68 292.44c-3.03.18-5.05 2.35-4.74 5.31.29 2.96 2.3 4.06 5.03 4.06 3.22 0 4.94-2.04 4.94-5.11 0-2.17-2.1-4.45-5.23-4.25ZM1677.32 288.73c-3.03.18-5.05 2.35-4.74 5.31.29 2.96 2.3 4.06 5.03 4.06 3.22 0 4.94-2.04 4.94-5.11 0-2.17-2.1-4.45-5.23-4.25Z"
        style={{
          fill: '#406229',
        }}
      />
      <path
        style={{
          fill: '#464640',
        }}
        d="m1672.35 288.07 14.62 4.14 1.49-6.15-16.01-2.24-.1 4.25zM1627.09 296.95l15.75-5.54-.62-4.33-16.96 3.6 1.83 6.27z"
      />
      <path
        d="M1729.85 969.96s-.61 63.54 4.06 88.7c4.68 25.16 24.61 69.33 24.5 75.42-.11 6.08-6.97 43.34-2.12 72.89 4.85 29.55 20.2 91.29 20.33 112.24.12 20.94.41 46.28.41 46.28l40.32-1.37s-2.94-68.48 4.89-106.45c7.84-37.97 9.73-76.9 5.95-96.69-3.8-19.79-15.9-58.36-17.05-83.82-1.14-25.46.37-105.43.37-105.43l-81.65-1.78v.02ZM1560.74 920.16s30.08 150.03 33.55 179.34c3.46 29.32-8.17 63.71-2.18 93.56 5.99 29.84 48.35 185.85 48.35 185.85l47 13.45s-15.2-37.85-19.72-76.12c-4.51-38.27 7.97-79.38 6.72-104.01s-14.26-71.8-14.97-84.93c-.72-13.13 10.29-45.81 6.01-75.02-4.27-29.22-9.58-116.12-9.58-116.12l-95.2-16.01.02.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1581.47 711.11s37.37 15.39 94.52 17.58 104.42-12.09 104.42-12.09l4.45 16.8s23.36 45.65 26.55 96.61c3.19 50.96 35.09 171.89 35.09 171.89s-39.34 5.41-71.18 10.72c-31.85 5.31-72.2-1.07-72.2-1.07s-33.97-93.43-41.4-157.13c-7.43-63.71-69.01-104.05-69.01-104.05l-11.24-39.29v.03Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#c)',
        }}
      >
        <path
          d="M1690.37 1000.16s53.32 2.9 70.48 2.04 98.98-14.36 98.98-14.36l.49 36.66-172.35 15.43 2.41-39.77Z"
          style={{
            fill: '#f1f1f3',
          }}
        />
      </g>
      <path
        d="M1547.69 1009.12s41.84-11.34 71.56-4.97c29.73 6.37 60.52 6.37 60.52 6.37s27.6-124.23 26.55-121.04c-1.07 3.19-12.75-161.39-12.75-161.39s-62.64-3.19-78.56-3.19-29.73-8.49-29.73-8.49l-2.12 15.92s-19.11 12.75-19.11 54.15-16.36 222.63-16.36 222.63v.02Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#d)',
        }}
      >
        <path
          d="M1530.19 997.91s46.31-12 78.88-7.72c32.59 4.28 84.29 11.83 84.29 11.83l-4.54 26.76-162.06 6.01 3.43-36.87v-.02Z"
          style={{
            fill: '#f1f1f3',
          }}
        />
      </g>
      <path
        d="M1643.21 888.75c.06-.59 5.84-59.73 10.89-81.12 6.37-26.99 15.1-42.04 15.46-42.66l2.99 1.75c-.09.15-8.83 15.26-15.08 41.7-5 21.15-10.77 80.05-10.81 80.65l-3.45-.34v.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1644.37 894.47a3.007 3.007 0 0 1-2.62-3.28l2.82-28.58c.17-1.66 3.1-.47 3.1-.47s3.06-.56 2.9 1.07l-2.82 28.58a3.001 3.001 0 0 1-3.29 2.7h-.08v-.02ZM1710.86 873.32c.02-.59-.12-70.02-2.45-91.87-2.96-27.58-9.71-43.59-10-44.27l-3.19 1.36c.08.15 6.85 16.25 9.74 43.27 2.32 21.61 2.45 90.8 2.44 91.4l3.46.09v.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1709.77 878.84c1.63-.08 2.9-1.43 2.87-3.06l-.56-28.7c-.03-1.66-3.05-.72-3.05-.72s-3-.81-2.97.84l.56 28.7c.03 1.66 1.4 2.99 3.06 2.96h.08l.02-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1608.66 380.1s3.45 8.84 18.18 28.5c14.75 19.66 38.32 39.77 38.32 39.77s27.81-28.41 37.63-42.16c9.82-13.75 11.99-36.92 11.99-36.92s44.22 16.21 60.43 22.6c16.21 6.39 30.3 14.88 33.73 22.74 3.45 7.87-18.51 57.84-19.98 78.97-1.48 21.13 4.91 112.52 4.42 134.12-.49 21.62 8.36 94.83 12.78 120.37 4.42 25.56 2.81 35.06 2.81 35.06s-85.79 14.39-140.32 18.33c-54.54 3.93-108.14-7.47-108.14-7.47s8.36-52.3 13.75-83.26 6.88-102.68 5.9-119.88c-.98-17.2-17.2-90.9-28.01-117.92-10.81-27.02-39.07-31.18-24.08-44.71 8.04-7.24 28.99-20.14 42.74-27.02s37.83-21.13 37.83-21.13l.02.02Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#e)',
        }}
      >
        <path
          d="M1586.04 360.64s15.49 37.14 32.68 57.78c17.2 20.63 46.31 45.59 46.31 45.59s34.4-34.6 46.69-50.33c12.29-15.72 18.56-65.17 18.56-65.17l-125.36 5.67-18.88 6.45v.02Z"
          style={{
            fill: '#f8f7f0',
          }}
        />
      </g>
      <path
        d="M1504.36 594.96s15.52 8.26 38.36 8.1c27.02-.21 49.13-6.19 49.13-6.19s3.14-127.43-.69-153.23c-3.83-25.8-57.58-23.39-66.35-11.25-8.77 12.14-12.93 87.36-13.45 103.2-.53 15.84-7.01 59.38-7.01 59.38ZM1761.47 578.22s39.98-6.56 59.68-6.42c19.7.15 35.94-5.41 35.94-5.41s-37.98-143.14-49.05-152.44c-11.07-9.29-46.74-25.05-46.74-25.05s-7.93 84.14-8.23 105.81c-.3 21.67 8.4 83.52 8.4 83.52Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <path
        d="M1614.14 374.17s-7.15 3.16 5.87 43.03c12.15 37.24 51.69 150.06 51.69 150.06l6.71-.24s26.9-115.75 35.45-151.26c10.02-41.58.55-48.22.55-48.22"
        style={{
          fill: 'none',
          stroke: '#272a3e',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.68px',
        }}
      />
      <path
        style={{
          fill: '#8cabbc',
        }}
        d="m1666.95 570.53 4.71-.8.69-4.35 5.12-.05.7 3.74 6.18.49-2.29 29.11-11.54-.17-3.57-27.97z"
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1671.55 589.08-.01 2.6h9.93v-2.92l-9.92.32z"
      />
    </svg>
  )
}

export default GymTeacherEnd
